<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="代理商ID" :value="3"></el-option>
                            <el-option label="代理商名称" :value="4"></el-option>
                            <el-option label="项目负责人" :value="5"></el-option>
                            <el-option label="合同编号" :value="6"></el-option>
                            <el-option label="账户名" :value="7"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.activityStatus" placeholder="请选择" size="small">
                        <el-option label="不限演出状态" :value="0"></el-option>
                        <el-option label="仅看销售中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.settlementStatus" placeholder="请选择" size="small">
                        <el-option label="不限代理费结款状态" :value="0"></el-option>
                        <el-option label="仅看未结款的" :value="1"></el-option>
                        <el-option label="仅看已结款的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.balanceType" placeholder="请选择" size="small">
                        <el-option label="不限结算方式" :value="0"></el-option>
                        <el-option label="仅看预付款的" :value="1"></el-option>
                        <el-option label="仅看后付款的" :value="2"></el-option>
                    </el-select>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="合同到期时间" :value="1"></el-option>
                                <el-option label="最新更新时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/agent/settle/exportReceivables')"  type="primary" icon="el-icon-download" size="small" @click="download1" :loading="downLoading1">导出结款信息</el-button>
            <el-button v-if="$utils.have('/agent/settle/batchReceivables')"  type="primary" icon="el-icon-tickets" size="small" @click="$refs.batch.show()">批量结款</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityTitle" label="演出名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="agentUserName" label="代理商名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="activityStatus" label="演出状态"></el-table-column>
                <el-table-column prop="settlementStatus" label="代理费结款状态" min-width="120"></el-table-column>
                <el-table-column prop="sellNum" label="销售票数"></el-table-column>
                <el-table-column prop="totalAmount" label="销售金额"></el-table-column>
                <el-table-column label="优惠" min-width="150">
					<template slot-scope="scope">
					    <p>秀动承担优惠：{{scope.row.discountAmount}}</p>
						<p>B类承担优惠：{{scope.row.busDiscountAmount}}</p>
					</template>
				</el-table-column>
                <el-table-column prop="income" label="实际收入" min-width="100"></el-table-column>
                <el-table-column prop="serviceFeeRatio" label="服务比例" min-width="150"></el-table-column>
                <el-table-column prop="serviceFee" label="服务费用"></el-table-column>
                <el-table-column prop="agentServiceFeeRatio" label="代理费占票提比例" min-width="120"></el-table-column>
                <el-table-column prop="agentServiceFee" label="代理商费用" min-width="100"></el-table-column>
                <el-table-column prop="settleAgentServiceFee" label="代理费实际打款金额" min-width="140"></el-table-column>
                <el-table-column prop="settlementTime" label="代理费打款时间" min-width="150"></el-table-column>
                <el-table-column prop="lastSessionEndTime" label="演出起止时间" min-width="180">
                    <template slot-scope="scope">
                        <p>起: {{scope.row.activityStartTime}}</p>
                        <p>止: {{scope.row.activityEndTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="contractSn" label="合同编号" min-width="130"></el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/agent/settle/info')"
                            type="text"
                            size="small"
                            icon="el-icon-tickets"
                            @click="$refs.dataView.show(scope.row.activityId)"
                            >结款信息</el-button>    
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <DataView ref="dataView" @onUpdate="getDataList"></DataView>
        <Batch ref="batch" @onUpdate="getDataList"></Batch>
    </div>
</template>

<script>
import Batch from './components/batch';
import DataView from './components/dataView';
const defaultParams = {
    pageNo:1,
    activityStatus: 0,
    balanceType: 0,
    beginTime: "",
    endTime: "",
    searchType: 1,
    searchValue: "",
    settlementStatus: 0,
    timeType: 1
}

export default {
    components:{DataView,Batch},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                timeType: parseInt(this.$route.query.timeType || 1),
                activityStatus: parseInt(this.$route.query.activityStatus || 0),
                balanceType: parseInt(this.$route.query.balanceType || 0),
                settlementStatus: parseInt(this.$route.query.settlementStatus || 0),
            },
            listLoading: true,
            datetimerange: [this.$route.query.beginTime || '' , this.$route.query.endTime || ''],
            downLoading1: false
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                beginTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/agent/settle/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
         //导出结款信息
        async download1(){
            // let filePath;
            this.downLoading1 = true;
            const res = await this.$request({
                url:'/agent/settle/exportReceivables',
                method: 'post',
                data: this.params,
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg} = res.data;
            if(state == 1){
                // filePath = result.url;
                this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                    confirmButtonText: '立即查看',
                    cancelButtonText: '稍后再看',
                    type: 'success',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.$router.push({path:'/workbench/downloadList'})
                }).catch(() => {})
            }else{
                this.downLoading1 = false;
                return this.$message.error(msg || '下载失败');
            }   

            this.downLoading1 = false;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>